export const sanitizeOptions = {
  allowedTags: ['abbr', 'time', 'b', 'br', 'i', 'u', 'strike', 'em', 'strong', 'a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'p', 'span', 'ul', 'ol', 'li', 'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td', 'colgroup', 'col', 'caption'],
  allowedAttributes: {
    '*': [
      'style',
      'class',
      'id',
      'test-id',
      'datetime',
      'colspan',
      'headers',
      'rowspan',
      'scope',
      'title',
      'aria-*',
      'role'
    ],
    a: ['href', 'target', 'download', 'aria-*']
  }
}
